import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Branch } from 'src/app/models/branch';
import { Menu } from 'src/app/models/menu';
import { SalesOrg } from 'src/app/models/sales-org';
import { AuthService } from 'src/app/services/auth.service';
import { BranchesService } from 'src/app/services/branches.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegisterService } from 'src/app/services/register.service';
import { SalesOrgService } from 'src/app/services/sales-org.service';


@Component({
  selector: 'app-auto-login',
  template: "",
  styleUrls: ['./auto-login.component.sass']
})
export class AutoLoginComponent implements OnInit {

  salesOrgs: Array<SalesOrg> = [];
  branches: Array<Branch> = [];
  constructor(private readonly route: ActivatedRoute, private readonly router: Router,
    private readonly authService: AuthService,
    private readonly salesorgService: SalesOrgService,
    private readonly branchService: BranchesService,
    private readonly configurationService: ConfigurationService,
    private readonly registerService: RegisterService,
    private readonly paramsService: ParamsService) {


  }

  async ngOnInit(): Promise<void> {

    this.route.queryParams.subscribe(async result => {

      if (!result.access_token) {
        this.router.navigate(["login"])
      }
      this.authService.removeTokenFromStorage();
      this.authService.saveTokenInStorage(result.access_token);

      this.salesOrgs = (await this.salesorgService.readSalesOrgs().toPromise()).response.content;
      this.branches = (await this.branchService.readBranches().toPromise()).response.content;
      let user = await this.authService.readProfile();
      if (!result.loadprev) {
        let filteredBranches = this.branches.filter(f => Array.from(user.branchCodes).some(s => s == f.code)).sort((a, b) => a.code.localeCompare(b.code))
        let filteredSalesOrgs = new Set(filteredBranches.map(m => m.salesOrg));
        this.configurationService.createSalesOrg(this.salesOrgs.filter(f => Array.from(filteredSalesOrgs).some(s => s == f.code)));
        let branchResult: any = {};
        this.salesOrgs.filter(f => Array.from(filteredSalesOrgs).some(s => s == f.code)).forEach(m => {
          branchResult[m.code] = filteredBranches.filter(x => x.salesOrg == m.code)
        })

        this.configurationService.createBranch(branchResult);

        //////////////////Select first branch /////////////////////////////////////////////////
        let firstBranch = Array.from(user.branchCodes)[0];
        let branchSelected: string | undefined;
        if (filteredBranches.length > 0) {
          if (filteredBranches.find(x => x.code == firstBranch)!.salesOrg == "1300") {
            if (!branchSelected)
              branchSelected = filteredBranches
                .find(x => x.salesOrg == "1600")?.code;
            if (!branchSelected)
              branchSelected = filteredBranches
                .find(x => x.salesOrg == "1500")?.code;
            if (!branchSelected)
              branchSelected = filteredBranches
                .find(x => x.salesOrg == "1400")?.code;
          }
        }
        if (!branchSelected)
          branchSelected = firstBranch;

        if (result.branchCode && filteredBranches.some(s => s.code == result.branchCode)) {
          branchSelected = result.branchCode;
        }
        ////////////////////////////////////////////////////////////////////////////////////////

        let firstBranchObj = filteredBranches.find(f => f.code == branchSelected);
        let firstSalesOrg = this.salesOrgs.filter(f => f.code == firstBranchObj?.salesOrg)[0];
        this.configurationService.createSelectedBranchAndSalesOrg({
          salesOrg: firstSalesOrg,
          branch: firstBranchObj!,
        });
      }
      else {
        this.configurationService.loadBranchesFromPrevSettings(false);
        if (result.branchCode) {
          const firstBranch = this.branches.find(f => f.code == result.branchCode)
          const firstSalesOrg = this.salesOrgs.filter(f => f.code == firstBranch?.salesOrg)[0];
          if (firstBranch && firstSalesOrg) {
            this.configurationService.createSelectedBranchAndSalesOrg({
              branch: firstBranch,
              salesOrg: firstSalesOrg
            });
          }
        }
      }

      await this.configurationService.configureFromCookies();

      this.authService.saveProfileInStorage(user);
      //}
      await this.authService.savePrivilegesInStorage();
      await this.authService.saveAccessInStorage();
      await this.authService.saveMenusInStorage();
      if (!result.loadprev) {
        this.authService.removeCreatCustomerAccess();
      }
      if (result.redirectTo) {
        this.configurationService.hideMenu();
        this.router.navigate([result.redirectTo]);
      }
      else {
        this.configurationService.showMenu();
        const menus: Array<Menu> = Array.from(JSON.parse(localStorage.getItem('menus') ?? JSON.stringify({})));

        if (menus.length > 0) {
          this.router.navigateByUrl(menus[0].redirectTo);
        } else {
          this.router.navigateByUrl('');
        }
      }
    });
  }

  migrateFromPreviousVersion() {
    const previousSettings = this.configurationService.readPreviousConfig();

    if (!previousSettings.physicalEstablishment || !previousSettings.register) {
      return this.migrateFromCookies();
    }
    this.configurationService.createPhysicalEstablishment(previousSettings.physicalEstablishment);
    this.configurationService.createRegister(previousSettings.register);
    this.configurationService.createSupervisor(previousSettings.supervisor);
    return true;
  }


  migrateFromCookies() {
    const physicalEstablishment = this.configurationService.getCookieObject("physicalEstablishment");
    const register = this.configurationService.getCookieObject("register");
    const supervisor = this.configurationService.getCookieObject("supervisor");

    if (!physicalEstablishment || !register) {
      return false;
    }
    this.configurationService.createPhysicalEstablishment(physicalEstablishment);
    this.configurationService.createRegister(register);
    this.configurationService.createSupervisor(supervisor);
    return true;
  }

}
